import { IBrandViewV2Response } from "@faire/web-api--source/indigofair/data/IBrandViewV2Response";

export function isReorderArchetype(brandView: IBrandViewV2Response): boolean {
  return !!brandView.brand_retailer_info?.has_prior_orders;
}
